import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { useHideTsmPointsNotificationLoyaltyBannerExperiment } from 'experiments/hide-tsm-pointsnotification-loyaltybanner/use-enable-item-detail-reorder-experiment';
import useAuth from 'hooks/auth/use-auth';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import { LoyaltyCtaBarView } from './loyalty-cta-bar.view';
import { PromoMessageRibbon } from './loyalty-ribbon';

/**
 *
 * <LoyaltyCtaBar /> displays below app header on homepage
 * If user is authenticated, displays number of rewards
 * otherwise prompts user to create account.
 *
 */
const LoyaltyCtaBar: FC<React.PropsWithChildren<unknown>> = () => {
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const showLoyaltyBannerV1 = useFlag(LaunchDarklyFlag.SHOW_LOYALTY_BANNER_V1);
  const hideLoyaltyCtaBarOnHome = useHideTsmPointsNotificationLoyaltyBannerExperiment();
  const { openSignInModal } = useAuth();
  const { navigate } = useNavigation();
  const { formatMessage } = useIntl();

  const handlePress = () => {
    if (loyaltyUser) {
      navigate(formatMessage({ id: 'routes.rewardsHistory' }));
    } else {
      openSignInModal();
    }
  };

  // lets be very sure we want to hide the brown Royal Perks bar with '===' assertions as these can be falsy when loading
  // do not hide on loading because it can cause simple home page onLayout measurement glitches if the bar does show up (it does normally presently)
  if (loyaltyEnabled === false || showLoyaltyBannerV1 === false || hideLoyaltyCtaBarOnHome) {
    return null;
  }
  const loading = !loyaltyUser && loyaltyLoading;
  const bestPromoId = loyaltyUser?.bestPromotion?.sanityId;

  return (
    <>
      <LoyaltyCtaBarView loading={loading} handlePress={handlePress} points={loyaltyUser?.points} />
      {bestPromoId && <PromoMessageRibbon promoId={bestPromoId} />}
    </>
  );
};

export default LoyaltyCtaBar;
